import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { removeepayToken, getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/home', '/mine', '/loginValidate', '/loginSetPW', '/PrivacyPolicy', '/tips', '/ArrivalTime']

router.beforeEach((to, from, next) => {
    document.title = "Smartrans";
    NProgress.start();
    if (getToken()) {
        if (to.path === '/') {
            next({ path: '/home', replace: true })
            NProgress.done()
        } else {
            next()
        }
    } else {
        // 没有token
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，直接进入
            next()
        } else {
            next({ path: '/login', replace: true }) // 否则全部重定向到登录页
            NProgress.done()
        }
    }
})
router.afterEach(() => {
    NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js